import React, { useEffect, useState } from 'react';
import api from '../lib/api';

const RANGES = [
  { k: 'today', l: 'Hoje' }, { k: 'yesterday', l: 'Ontem' },
  { k: 'week', l: 'Esta Semana' }, { k: 'month', l: 'Este Mês' },
];

const KPI = ({ label, value, accent }) => (
  <div className="rounded-xl border border-border/70 bg-card p-4">
    <p className="text-[10px] tracking-widest text-muted-foreground/70 font-bold uppercase">{label}</p>
    <p className={`font-display font-black text-2xl mt-1 ${accent || ''}`}>{value}</p>
  </div>
);

export const BdcDashboard = () => {
  const [range, setRange] = useState('today');
  const [data, setData] = useState(null);

  useEffect(() => {
    api.get(`/bdc/dashboard?range=${range}`).then(({ data: d }) => setData(d)).catch(() => {});
  }, [range]);

  const k = data?.kpis || {};
  return (
    <div className="space-y-5" data-testid="bdc-dashboard">
      <div className="flex gap-1 bg-muted/40 border border-border rounded-lg p-1 w-fit">
        {RANGES.map((r) => (
          <button key={r.k} data-testid={`range-${r.k}`} onClick={() => setRange(r.k)} className={`px-3.5 py-1.5 rounded-md text-xs font-semibold transition-colors ${range === r.k ? 'bg-primary text-white' : 'text-muted-foreground hover:text-foreground'}`}>{r.l}</button>
        ))}
      </div>
      <div className="grid grid-cols-2 md:grid-cols-4 xl:grid-cols-6 gap-3">
        <KPI label="New Leads" value={k.new_leads ?? '—'} accent="text-sky-400" />
        <KPI label="Unassigned" value={k.unassigned ?? '—'} accent={k.unassigned > 0 ? 'text-amber-400' : ''} />
        <KPI label="Leads Ativos" value={k.assigned ?? '—'} />
        <KPI label="Calls" value={k.calls ?? '—'} />
        <KPI label="Contacted" value={k.contacted ?? '—'} accent="text-teal-400" />
        <KPI label="Follow-Ups Due" value={k.follow_ups_due ?? '—'} accent={k.follow_ups_due > 0 ? 'text-red-400' : ''} />
        <KPI label="Appts Hoje" value={k.appointments_today ?? '—'} accent="text-violet-400" />
        <KPI label="Appts Amanhã" value={k.appointments_tomorrow ?? '—'} />
        <KPI label="Sales Assignment" value={k.sales_assignment_needed ?? '—'} accent={k.sales_assignment_needed > 0 ? 'text-orange-400' : ''} />
        <KPI label="Lost" value={k.lost ?? '—'} />
        <KPI label="Appt Rate" value={`${k.appointment_rate ?? 0}%`} accent="text-emerald-400" />
        <KPI label="Resposta Média" value={`${k.avg_response_min ?? 0}min`} />
      </div>
      <div className="rounded-xl border border-border/70 bg-card p-5 overflow-x-auto">
        <p className="font-display font-black text-sm uppercase tracking-wide mb-4">Performance por BDC Agent</p>
        <table className="w-full text-sm">
          <thead>
            <tr className="text-left text-muted-foreground text-xs tracking-wider border-b border-border/70">
              <th className="pb-3 font-semibold">AGENT</th><th className="pb-3 font-semibold">RECEBIDOS</th>
              <th className="pb-3 font-semibold">ATIVOS</th><th className="pb-3 font-semibold">CALLS</th>
              <th className="pb-3 font-semibold">CONTATOS</th><th className="pb-3 font-semibold">APPTS</th>
              <th className="pb-3 font-semibold">LOST</th><th className="pb-3 font-semibold">CONTACT RATE</th>
              <th className="pb-3 font-semibold">APPT RATE</th>
            </tr>
          </thead>
          <tbody>
            {(data?.agents || []).map((a) => (
              <tr key={a.user_id} className="border-b border-border/70">
                <td className="py-3 font-medium">{a.name}</td>
                <td className="py-3">{a.received}</td><td className="py-3">{a.active}</td>
                <td className="py-3">{a.calls}</td><td className="py-3">{a.contacts}</td>
                <td className="py-3">{a.appointments}</td><td className="py-3">{a.lost}</td>
                <td className="py-3 text-teal-400">{a.contact_rate}%</td>
                <td className="py-3 text-emerald-400">{a.appointment_rate}%</td>
              </tr>
            ))}
          </tbody>
        </table>
        {(data?.agents || []).length === 0 && <p className="text-sm text-muted-foreground/60 text-center py-8">Nenhum BDC Agent cadastrado.</p>}
      </div>
    </div>
  );
};
